import store from 'infra/redux/store'
import React, { useEffect, useRef, useState } from 'react'
import { status } from 'infra/redux/reducers'

const Loader = () => {
  const [progress, setProgress] = useState(0)
  const [visible, setVisible] = useState(false)
  const loadingRef = useRef(false)
  const timerRef = useRef(null)
  const progressRef = useRef(0)

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }

  const increment = () => {
    const current = progressRef.current
    // Slow down as it approaches 90%
    let amount = 0
    if (current < 20) amount = 8
    else if (current < 40) amount = 6
    else if (current < 60) amount = 4
    else if (current < 80) amount = 2
    else if (current < 90) amount = 0.8
    else return // stall at 90 until loading finishes

    const next = Math.min(current + amount, 90)
    progressRef.current = next
    setProgress(next)
    timerRef.current = setTimeout(increment, 250)
  }

  const start = () => {
    clearTimer()
    progressRef.current = 0
    setProgress(0)
    setVisible(true)
    timerRef.current = setTimeout(increment, 100)
  }

  const finish = () => {
    clearTimer()
    progressRef.current = 100
    setProgress(100)
    // hide after transition completes
    timerRef.current = setTimeout(() => {
      setVisible(false)
      setProgress(0)
      progressRef.current = 0
    }, 400)
  }

  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      const state = store.getState()
      const isLoading = Object.keys(state).some((key) => state[key].status === status.LOADING)

      if (isLoading && !loadingRef.current) {
        loadingRef.current = true
        start()
      } else if (!isLoading && loadingRef.current) {
        loadingRef.current = false
        finish()
      }
    })
    return () => {
      unsubscribe()
      clearTimer()
    }
  }, [])

  if (!visible) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: '44px',
        left: 0,
        width: '100%',
        height: '3px',
        zIndex: 1499,
        backgroundColor: 'transparent'
      }}
    >
      <div
        style={{
          height: '100%',
          width: `${progress}%`,
          backgroundColor: '#1e7afa',
          transition: progress === 100 ? 'width 0.3s ease-out' : 'width 0.25s ease',
          borderRadius: '0 2px 2px 0',
          boxShadow: '0 0 8px 2px #006CFF, 0 0 18px 4px #3d8bff66'
        }}
      />
    </div>
  )
}

export default Loader
